/**
 * Couche service « Journal des actions ».
 *
 * Une école ne reçoit que ses propres actions (`/activity`) ; le super-administrateur consulte celles
 * d'une école choisie ou de toute la plateforme (`/platform/activity`). Conservation : 12 mois.
 */
import { http } from "./http";
import type { ActivityAction, ActivityLogEntry } from "@/types";

interface ApiActivityLog {
  id: number;
  createdAt: string;
  schoolId: number | null;
  actorName: string;
  actorRole: string | null;
  module: string;
  action: ActivityAction;
  description: string;
  target: string | null;
  ip: string | null;
  device: string | null;
}

/** Au plus 1 000 entrées récentes (10 pages) : au-delà, filtrer par période. */
const MAX_PAGES = 10;

export interface ListActivityParams {
  /** Super-administrateur : école ciblée (vide = toutes). */
  schoolId?: string;
  /** Vrai pour la console de la plateforme. */
  platform?: boolean;
  dateFrom?: string;
  dateTo?: string;
}

function toEntry(e: ApiActivityLog): ActivityLogEntry {
  return {
    id: String(e.id),
    schoolId: e.schoolId === null ? null : String(e.schoolId),
    createdAt: e.createdAt,
    actorName: e.actorName,
    actorRole: e.actorRole ?? "",
    module: e.module,
    action: e.action,
    description: e.description,
    target: e.target ?? undefined,
    ip: e.ip ?? "",
    device: e.device ?? "",
  };
}

/** Journal trié du plus récent au plus ancien. */
export async function listActivity(params: ListActivityParams = {}): Promise<ActivityLogEntry[]> {
  const path = params.platform ? "/platform/activity" : "/activity";
  const items: ApiActivityLog[] = [];
  for (let page = 1; page <= MAX_PAGES; page += 1) {
    const chunk = await http.get<ApiActivityLog[]>(path, {
      page,
      limit: 100,
      schoolId: params.platform ? params.schoolId : undefined,
      dateFrom: params.dateFrom,
      dateTo: params.dateTo,
    });
    items.push(...chunk);
    if (chunk.length < 100) break;
  }
  return items.map(toEntry);
}
